import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'
import Intro from './routes/Intro'
import Onboarding from './routes/Onboarding'
import Statement from './routes/Statement'
import Interstitial from './routes/Interstitial'
import Print from './routes/Print'
import Summary from './routes/Summary'
import SummaryFocus from './routes/SummaryFocus'

export default (store) => ({
  path: 'health-and-happiness-tool',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const HealthAndHappinessTool = require('./containers/HealthAndHappinessToolContainer').default
      const reducer = require('./modules/reducer').default
      const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'healthAndHappinessTool'  */
      injectReducer(store, { key: 'healthAndHappinessTool', reducer })
      injectSagas(store, { key: 'healthAndHappinessTool', sagas })

      /*  Return getComponent   */
      cb(null, HealthAndHappinessTool)

    /* Webpack named bundle   */
    }, 'HealthAndHappinessTool')
  },

  indexRoute: { onEnter: (nextState, replace) => replace('/health-and-happiness-tool/intro') },

  childRoutes: [
    Intro(store),
    Onboarding(store),
    Statement(store),
    Interstitial(store),
    Print(store),
    Summary(store),
    SummaryFocus(store)
  ]
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/HealthAndHappinessTool/index.js
 **/